import Vue from 'vue'
import Vuex from 'vuex'
import { BASEURL, GETMETERLIST } from "@/api/ApiConfig";
import request from '@/api/request.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    UserMeterList: [],
    WaterType:0, //农村:0 城市:1
    color: "#04AA96",// 网厅
    // color: "#00AE7E",//蒙速办
  },
  mutations: {
    setUserMeterList: (state, UserMeterList) => {
      state.UserMeterList = UserMeterList
      sessionStorage.setItem('UserMeterList',JSON.stringify(UserMeterList))
      console.log(JSON.parse(sessionStorage.getItem("UserMeterList")))
    },
    setWaterType:(state, WaterType)=>{
      state.WaterType = WaterType
    }
  },
  actions: {
    getUserMeterList({ commit }) {
      return new Promise((resolv, reject) => {
        request({
          url: GETMETERLIST,
          baseURL: BASEURL,
          method: "post",
          params: {},
        }).then(res => {
          
          if (res.status == 0) {
            commit('setUserMeterList', res.data)
          } else {
          }
          resolv(res)
        });
      })
    }
  },
  modules: {
  }
})
